import script from "./CollapsiblePropertyRecommendation.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsiblePropertyRecommendation.vue?vue&type=script&setup=true&lang=js"

import "./CollapsiblePropertyRecommendation.vue?vue&type=style&index=0&id=7efe969c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7efe969c"]])

export default __exports__